import React from "react";
import { ValidatorComponent } from "react-material-ui-form-validator";
import { KeyboardDatePicker } from "@material-ui/pickers";
import TextInput from "../text/TextInput";
import DateHelper from "../../../../../helpers/DateHelper";
import TextField from '@mui/material/TextField';
class DateControlInput extends ValidatorComponent
{

    /***************
     * CONSTRUCTOR *
     ***************/

    constructor(props) {

        super(props);

        this.state = {
            selectedDate: this.props.value && this.props.value!=='' ? new Date(this.props.value) : null,
            reset : false,
        };

    }

    // Restore date if is set in props.value
    getSnapshotBeforeUpdate(prevProps){


        // Reset case from parent
        if(this.state.value==='' && this.props.value==='' && this.getInputValue()===prevProps.value && this.getInputValue()!=='' && prevProps.value!==''){
            this.getInput().value='';
            this.setState({ selectedDate :  null , value : '' , reset : true });
            return null;
        }

        // Reset has been done remove reset flag
        if(this.state.reset===true && !this.state.value && !prevProps.value && !this.props.value && this.getInputValue()===''){
            this.setState({ reset : false });
            return null;
        }

        /*
        // Special case when type really fast after an invalide date input does not update so force to update
        if(prevProps.value==='' && this.props.value==='' && this.state.value==='' && this.getInputValue()!==''){
          if(!this.state.reset){
            this.handleParentChange(new Date(this.getInputValue()));
          }
        }
        */

        // Update props if it changed
        if(this.props.value && prevProps.value!==this.props.value && this.props.value!==''){
            this.handleLocalChange(this.props.value);
        }

        return null;
    }

    /**********
     * EVENTS *
     **********/

        // Update value
    handleDateChange = (date) => {

        //Change value in parent
        this.handleParentChange(date);

        //Change value locally
        this.handleLocalChange(date);
    }

    // Update value in local
    handleLocalChange = (date) => {
        this.setState({selectedDate : (!date || date==='' ? null : new Date(date)) });
    }

    // Update value in parent
    handleParentChange = (date) => {
        // Update parent value
        let event = { target: {} };
        event.target.name = this.props.name;
        event.target.value = date;
        this.props.handleChange(event);
    }

    /********
     * UTIL *
     ********/

    getInputValue =() =>{

        let tmpValue = this.getInput().value.replace('_','');
        let formatedValue= '';
        if(tmpValue.match(/[0-9]{2}\/[0-9]{2}\/[0-9]{4}/g)){
            formatedValue=tmpValue.split('/').reverse().join('-');
        }

        return formatedValue;
    }

    getInput = () => {
        return document.querySelector('input[name='+this.props.name+']');
    }

    /**********
     * RENDER *
     **********/

    /**
     * Render the component
     */
    renderValidatorComponent() {

        let { isValid } = this.state;

        const {
            //errorMessages,
            //validators,
            //requiredError,
            //validatorListener,
            name,
            label,
            //handleChange,
            //value,
            //displayCondition,
            readOnly,
            disabled
        } = this.props;


        let { helperText } = this.props;

        if(!helperText || helperText==='') helperText="format jj/mm/aaaa";

        let {
            minDateMessage, maxDateMessage
        } = this.props;

        minDateMessage = minDateMessage ? minDateMessage : 'La date ne devrait pas être inférieur à la date minimale';
        maxDateMessage = maxDateMessage ? maxDateMessage : 'La date ne devrait pas être supérieur à la date maximale';


        return (
            <>
                {
                    readOnly===true ? (
                        <TextInput
                            xs={12}
                            sm={12}
                            name={name}
                            label={label}
                            value={DateHelper.InputDateToFr(this.state.value)}
                            inputProps={{ readOnly : true }}
                            disabled={disabled}
                        />
                    ) : (

                        <TextField
                            type="date"
                            name={name}
                            label={label}
                            value={this.state.selectedDate ? this.state.selectedDate.toISOString().split('T')[0] : ''}
                            onChange={(e) => this.handleDateChange(e.target.value)}
                            disabled={disabled}
                            fullWidth
                            variant="outlined"
                            error={isValid === false}
                            helperText={isValid === false ? this.getErrorMessage() : helperText}
                            InputLabelProps={{
                                 shrink: true,
                            }}
                            InputProps={{
                                style: { height: '55px' } // Set the height here
                            }}
                        />

                    )
                }
            </>
        )
    }
}


export default DateControlInput;
